import { render, staticRenderFns } from "./node-details.vue?vue&type=template&id=022eaf3a"
import script from "./node-details.vue?vue&type=script&lang=js"
export * from "./node-details.vue?vue&type=script&lang=js"
import style0 from "./node-details.vue?vue&type=style&index=0&id=022eaf3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports